import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Компонент SEO для установки мета-тегов на каждой странице.
 * Использует react-helmet-async.
 *
 * @param {Object} props
 * @param {string} props.title — заголовок страницы
 * @param {string} props.description — описание
 * @param {string} props.image — URL картинки для OG (относительный или абсолютный)
 * @param {string} props.url — относительный URL страницы (например /collection/star-wars-games)
 */
export default function SEO({ title, description, image, url }) {
  const siteUrl = 'https://plkapp.ru';
  const defaultTitle = 'Полка — социальная сеть для фильмов, книг, игр и музыки';
  const defaultDescription = 'Собирайте, оценивайте и делитесь любимыми фильмами, сериалами, книгами, играми и музыкой в социальной сети Полка. Удобные списки, рецензии и рекомендации.';
  const defaultImage = '/ogimage.webp';

  const pageTitle = title ? `${title.replace(/\s*\|\s*Полка$/i, '')} | Полка` : defaultTitle;
  const pageDescription = description || defaultDescription;
  const absolute = (value, fallback) => {
    try { const result = new URL(value || fallback, siteUrl); return ['http:', 'https:'].includes(result.protocol) ? result.href : new URL(fallback, siteUrl).href; }
    catch { return new URL(fallback, siteUrl).href; }
  };
  const pageImage = absolute(image, defaultImage);
  const pageUrl = absolute(url, '/');

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <link rel="canonical" href={pageUrl} />
      <meta name="description" content={pageDescription} />

      {/* Open Graph */}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:image:alt" content={title || 'Полка'} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Полка" />
      <meta property="og:locale" content="ru_RU" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={pageImage} />
    </Helmet>
  );
}